import { IHpp } from "../IStancerPayment";

export interface IHppResponse {
    url: string;
    paymentIntentId: string;
}

export const mapHpp = (hppResponse: IHppResponse): IHpp => ({
    url: hppResponse.url,
    paymentIntentId: hppResponse.paymentIntentId,
});
